<template>
  <v-sheet class="basicConfigurator">
    <v-row class="header">
      <v-col>
        <h1 class="display-1">{{ title }}</h1>
      </v-col>
      <v-col>
        <v-row>
          <v-spacer/>
          <v-col cols="auto">
            <v-btn v-if="showBuyButton" class="buyButtonTop" color="primary" right @click="addToBasket">
              <v-icon>add_shopping_cart</v-icon>
              {{ buyButtonText }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <slot/>
    <v-row class="actionButtons" justify="center">
      <v-col cols="auto">
        <v-btn v-if="addedToBasket" class="actionButton" color="primary" @click="goToStep(3)">
          <v-icon>arrow_back</v-icon>
          {{ $t("BUTTON_BACK_TO_PRODUCTS") }}
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn v-if="showBuyButton" class="actionButton" color="primary" @click="addToBasket">
          <v-icon>add_shopping_cart</v-icon>
          {{ buyButtonText }}
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn v-if="addedToBasket" class="actionButton" color="primary" @click="configureAgain">
          <v-icon>replay</v-icon>
          {{ $t("BUTTON_CONFIGURE_AGAIN") }}
        </v-btn>
      </v-col>
    </v-row>

  </v-sheet>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, ProductDto} from "@swagger";
import ImageSelector from "@/components/product-configuration/ImageSelector.vue";

@Component({
  components: {
    ImageSelector,
    ImageBatchSelector: () => import("@/components/product-configuration/ImageBatchSelector.vue")
  }
})
export default class BasicConfigurator extends BasicComponent {

  @Prop(Array) value: ConfiguredImageDto[][]; // Multiple products can be configured at once, an image array for each
  @Prop(Object) product: ProductDto;
  @Prop(Boolean) configurationValid: boolean; // Whether the product may be added to the basket

  addedToBasket: boolean = false;
  
  addToBasket(): void {
    let firstSuccess = true, firstError = true;
    for (let images of this.value) {
      this.addArticleToBasket(this.product.id, images, false, () => {
        if (firstSuccess) {
          this.addedToBasket = true;
          this.$emit("addedToBasket");
          firstSuccess = false;
        }
      }, (error) => {
        if (firstError) {
          this.$emit("error", error);
          firstError = false;
        }
      })
    }
  }

  configureAgain(): void {
    this.addedToBasket = false;
    this.$emit("reset");
  }

  get showBuyButton(): boolean {
    return this.configurationValid;
  }

  get title(): string {
    return this.$t("CONFIGURATOR_TITLE").toString().replace("{name}", this.product.name);
  }

  get buyButtonText(): string {
    if (this.value.length > 1) {
      return this.$t("BUTTON_ADD_MULTIPLE_TO_BASKET").toString().replace("{amount}", this.value.length.toString());
    }
    return this.$t("BUTTON_ADD_TO_BASKET").toString();
  }

}

</script>
<style lang="scss" scoped>
.basicConfigurator {
  padding: 30px;
  max-height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;

  .header {
    margin-bottom: 10px;
  }
}

.buyButtonTop {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
<style lang="scss">
.actionButtons {
  width: 100%;
  position: absolute;
  bottom: 20px;
  z-index: 12;

  .col {
    padding: 8px;
  }
}
</style>
